import * as React from "react";
import IDream from "motw_core/Entity/IDream";

export function CampaignFilterInfoText({
    selectedCampaignId,
    allDreams,
}: {
    selectedCampaignId: number | null;
    allDreams: IDream[];
}) {
    if (selectedCampaignId === null || selectedCampaignId === 0) {
        return null;
    }

    const campaignName = allDreams.find(
        (dream) => dream.id === selectedCampaignId
    )?.name;

    return (
        <div style={{ background: "rgb(191 136 0 / 25%)", marginTop: `5px` }}>
            <span style={{ opacity: 0.5 }}>viewing campaign </span>
            <span>{campaignName}</span>
        </div>
    );
}
